import ActivityCard from "@/components/ActivityCard";
import { Activity } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface HomepageActivitiesSectionProps {
  activities: Activity[];
  showMoreButton: boolean;
}

const HomepageActivitiesSection = ({ activities, showMoreButton }: HomepageActivitiesSectionProps) => {
  const visibleActivities = activities.slice(0, 2);

  return (
    <section className="py-20 overflow-hidden" aria-labelledby="activities-heading">
      <div className="container">
        <header className="text-center mb-12 scroll-fade-in">
          <p className="text-primary font-semibold mb-2">Leuk met alpaca's</p>
          <h2 id="activities-heading" className="text-3xl md:text-4xl font-bold mb-4">
            Welke activiteiten kun je bij ons doen?
          </h2>
        </header>

        <div className="mx-auto max-w-6xl px-2 sm:px-4 md:px-2 lg:px-0">
          <div className="grid grid-cols-1 justify-items-center gap-5 md:gap-3 lg:gap-6 md:grid-cols-2">
            {visibleActivities.map((activity, index) => (
              <article
                key={activity.id}
                className="scroll-fade-in w-full min-w-0 max-w-sm md:max-w-none"
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                <ActivityCard activity={activity} />
              </article>
            ))}
          </div>
        </div>
        {showMoreButton && (
          <div className="text-center mx-[6px] pt-[46px]">
            <Button size="lg" variant="outline" className="text-lg px-8" asChild>
              <Link to="/activiteiten">Meer activiteiten</Link>
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default HomepageActivitiesSection;
